import Rule from "../../../common/rule";
import FootballState from "../../state/football-state";

export default class KickOff extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return fragment.associatedState === FootballState.KickOff;
    }
    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const kickFragment = play.getFirstFragment(FootballState.Kick);
        ruleContext.setAwardFirstDown(true);
        gameContext.triggerKO = false;
        gameContext.setDriveContext({
            triggerDrive: true
        });
        let newPosition = fragment.kickedTo;
        gameContext.kickingOffTeamId = kickFragment?.kickedBy?.teamId;
        if (gameContext.firstQtrKickoffTeamId === null) {
            gameContext.firstQtrKickoffTeamId = gameContext.kickingOffTeamId;
        }

        gameContext.setFieldPosition(newPosition);
    }
}
